import { ACADEMIC_STRUCTURE, UI_CONSTANTS } from './constants.js';

/**
 * Convert number to ordinal (1st, 2nd, 3rd, etc.)
 * @param {number} number - The number to convert
 * @returns {string} - The ordinal string
 */
export const getOrdinal = (number) => {
  const suffixes = UI_CONSTANTS.ORDINAL_SUFFIXES;
  const v = number % 100;
  return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

/**
 * Get season name from semester number with semester prefix
 * @param {number} semester - The semester number (1-4)
 * @param {number} year - The year
 * @returns {string} - Formatted season name (e.g., "Semester 1 - Autumn 2025")
 */
export const getSeasonName = (semester, year) => {
  const season = ACADEMIC_STRUCTURE.SEASON_NAMES[semester] || 'Unknown';
  return `Semester ${semester} - ${season} ${year}`;
};

/**
 * Get valid semesters for a given year
 * @param {number} year - The year to check
 * @returns {number[]} - Array of valid semester numbers
 */
export const getValidSemesters = (year) => {
  return ACADEMIC_STRUCTURE.VALID_YEARS[parseInt(year)] || [];
}; 